import { i as e, r as t } from "./client-C353vByp.js";
import { useEffect as n, useRef as r } from "react";
import { create as i } from "zustand";
import { Fragment as a, jsx as o } from "react/jsx-runtime";
//#region src/keepalive.ts
var s = "agion-auth-keepalive", c = 27e5, l = 3e4;
function u(e) {
	let t = e.intervalMs ?? 27e5, n = e.now ?? (() => Date.now()), r = !1, i = null, a = 0, o = 0, c = null, u = async () => {
		if (!r && !(typeof document < "u" && document.hidden)) try {
			if (await e.client.touchSession(e.touchUrl)) {
				a = n(), o = 0, e.onTouchResult?.("ok");
				return;
			}
			if ((e.onUnauthorized ? await e.onUnauthorized() : "authenticated") === "unauthenticated") {
				e.onTouchResult?.("unauthorized"), r = !0;
				return;
			}
			o += 1, e.onTouchResult?.("transient_error");
		} catch (t) {
			o += 1, console.warn("[auth] keepalive transient failure", t), e.onTouchResult?.("transient_error");
		}
	}, d = () => {
		if (r) return;
		i !== null && (clearTimeout(i), i = null);
		let e = t;
		if (o > 0) {
			let n = Math.min(l, 1e3 * 2 ** Math.min(o, 5));
			e = Math.min(t, n);
		}
		i = setTimeout(async () => {
			await u(), d();
		}, e);
	}, f = async () => {
		r || typeof document < "u" && (document.hidden || n() - a >= t / 2 && (await u(), d()));
	};
	typeof document < "u" && document.addEventListener("visibilitychange", f);
	let p = typeof navigator < "u" && "locks" in navigator && typeof navigator.locks?.request == "function", m = async () => {
		await u(), d(), await new Promise((e) => {
			c = e;
		});
	};
	return p ? navigator.locks.request(s, { mode: "exclusive" }, async () => {
		r || await m();
	}).catch((e) => {
		console.warn("[auth] keepalive lock acquisition failed, running unlocked", e), r || m();
	}) : m(), () => {
		r = !0, i !== null && (clearTimeout(i), i = null), typeof document < "u" && document.removeEventListener("visibilitychange", f), c &&= (c(), null);
	};
}
//#endregion
//#region src/unauthorized.ts
var d = null;
function f() {
	return d || (d = (async () => {
		await Promise.resolve();
		try {
			let e = x.getState(), t = e.client, n = e.config;
			if (!t || !n || !e.isAuthenticated) return "unauthenticated";
			let r = await t.checkSession();
			return r.status === "ok" ? (x.getState().setAuth(r.user, r.sessionData), "authenticated") : r.status === "unavailable" ? (console.warn("[auth] handleUnauthorized: sign-in service unavailable, treating as transient"), "authenticated") : (x.getState().reset(), "unauthenticated");
		} catch (e) {
			return console.warn("[auth] handleUnauthorized: probe failed, treating as transient", e), "authenticated";
		} finally {
			d = null;
		}
	})(), d);
}
//#endregion
//#region src/store.tsx
var p = "[auth]", m = 2, h = 1, g = 30, _ = 3, v = 3, y = 1e3;
function b(e, t) {
	return Math.min(g, Math.min(g, Math.max(h, t ?? m)) * 2 ** (e - 1)) * 1e3;
}
var x = i()((e, t) => ({
	user: null,
	isAuthenticated: !1,
	isLoading: !0,
	error: null,
	sessionData: null,
	sessionCheckUnavailable: !1,
	client: null,
	config: null,
	setAuth: (t, n) => e({
		user: t,
		isAuthenticated: !0,
		isLoading: !1,
		error: null,
		sessionData: n,
		sessionCheckUnavailable: !1
	}),
	setLoading: (t) => e({ isLoading: t }),
	setError: (t) => e({
		user: null,
		isAuthenticated: !1,
		isLoading: !1,
		error: t,
		sessionData: null
	}),
	reset: () => e({
		user: null,
		isAuthenticated: !1,
		isLoading: !1,
		error: null,
		sessionData: null,
		sessionCheckUnavailable: !1
	}),
	setSessionCheckUnavailable: (t) => e({ sessionCheckUnavailable: t }),
	logout: async () => {
		let { client: n } = t();
		e({
			user: null,
			isAuthenticated: !1,
			isLoading: !1,
			error: null,
			sessionData: null,
			sessionCheckUnavailable: !1
		}), n && await n.logout();
	}
}));
function S({ config: i, children: s }) {
	let c = r(void 0), l = r(0);
	c.current || (c.current = new t(i), x.setState({
		client: c.current,
		config: i
	}));
	let d = c.current;
	return n(() => {
		let t = !1, n, r = (e) => new Promise((t) => {
			n = setTimeout(t, e);
		});
		return (async () => {
			if (i.hasAuthCallbackRoute && e(window.location.pathname)) return;
			if (i.mockAuth) {
				let e = {
					id: i.mockUser?.id ?? "dev-admin-123",
					email: i.mockUser?.email ?? "admin@agion.local",
					name: i.mockUser?.name ?? "Dev Admin",
					role: i.mockUser?.role ?? "admin",
					organizationId: i.mockUser?.organizationId ?? "mock-org-123",
					organizationName: i.mockUser?.organizationName ?? "Mock Organization",
					...i.mockUser
				}, t = {
					authenticated: !0,
					userId: e.id,
					email: e.email,
					role: e.role,
					organizationId: e.organizationId,
					organizationName: e.organizationName
				};
				x.getState().setAuth(e, t), console.warn(p, "Mock auth enabled — using mock user data");
				return;
			}
			x.getState().setLoading(!0);
			let n = !1, a = 0;
			for (;;) {
				let e = await d.checkSession();
				if (t) return;
				if (e.status === "ok") {
					x.getState().setAuth(e.user, e.sessionData), l.current = Date.now();
					return;
				}
				if (e.status === "unauthenticated") {
					if (!n) {
						if (n = !0, console.debug(p, "Mount probe found no session, retrying once before reset"), await r(y), t) return;
						continue;
					}
					console.debug(p, "Mount session check found no session after retry"), x.getState().reset();
					return;
				}
				a += 1, a >= _ && x.getState().setSessionCheckUnavailable(!0);
				let i = b(a, e.retryAfterSec);
				if (console.debug(p, "Sign-in service unavailable on mount, retrying", {
					attempt: a,
					delayMs: i
				}), await r(i), t) return;
			}
		})(), () => {
			t = !0, n !== void 0 && clearTimeout(n);
		};
	}, []), n(() => {
		if (i.revalidateOnFocus === !1 || i.mockAuth) return;
		let e = i.revalidateThrottleMs ?? 3e4, t = !1, n = !1, r, a = (e) => new Promise((t) => {
			r = setTimeout(t, e);
		}), o = async () => {
			let e = !1, n = 0;
			for (;;) {
				let r = await d.checkSession();
				if (l.current = Date.now(), t || !x.getState().isAuthenticated) return;
				if (r.status === "ok") {
					x.getState().setAuth(r.user, r.sessionData);
					return;
				}
				if (r.status === "unauthenticated") {
					if (!e) {
						if (e = !0, console.debug(p, "Focus probe found no session, retrying once before reset"), await a(y), t) return;
						continue;
					}
					console.warn(p, "Session expired during background — clearing auth state"), x.getState().reset();
					return;
				}
				if (n += 1, n >= _ && x.getState().setSessionCheckUnavailable(!0), n > v) {
					console.warn(p, "Sign-in service unavailable on focus — keeping the session, will check on a later focus");
					return;
				}
				if (await a(b(n, r.retryAfterSec)), t) return;
			}
		}, s = async () => {
			if (document.visibilityState !== "visible" || n || Date.now() - l.current < e) return;
			let { isAuthenticated: t } = x.getState();
			if (t) {
				console.debug(p, "Re-validating session on focus"), n = !0;
				try {
					await o();
				} finally {
					n = !1;
				}
			}
		};
		return document.addEventListener("visibilitychange", s), () => {
			t = !0, r !== void 0 && clearTimeout(r), document.removeEventListener("visibilitychange", s);
		};
	}, []), n(() => {
		if (i.mockAuth || i.enableKeepalive === !1) return;
		let e = x.getState().isAuthenticated, t = null, n = (e) => {
			e && !t ? t = u({
				client: d,
				intervalMs: i.keepaliveIntervalMs,
				touchUrl: i.keepaliveUrl,
				onUnauthorized: f
			}) : !e && t && (t(), t = null);
		};
		n(e);
		let r = x.subscribe((e, t) => {
			e.isAuthenticated !== t.isAuthenticated && n(e.isAuthenticated);
		});
		return () => {
			r(), t &&= (t(), null);
		};
	}, []), /* @__PURE__ */ o(a, { children: s });
}
function C() {
	return x;
}
function w() {
	let e = x((e) => e.config);
	if (!e) throw Error("AuthProvider not mounted yet");
	return e;
}
//#endregion
export { f as a, u as c, C as i, x as n, c as o, w as r, s, S as t };

//# sourceMappingURL=store-CfeUiT2k.js.map